import { AppConfig } from "app/NativeActions";

const contentful = require("contentful/dist/contentful.browser.min.js");

const client = contentful.createClient({
  space: AppConfig().contentful_space,
  accessToken: AppConfig().contentful_token
});

export const loadDashboardVideoTutorial = () => {
  return client.getEntries({
    content_type: "dashboardTutorialVideo"
  });
};

export const loadDashboardSuccessSteps = () => {
  return client.getEntries({
    content_type: "dashboardSuccessSteps"
  });
};

export const loadDashboardUpcomingWebinars = () => {
  return client.getEntries({
    content_type: "dashboardWebinar",
    order: "fields.startAt",
    "fields.startAt[gt]": new Date().toISOString(),
    limit: 3
  });
};

export const loadDashboardCaseStudies = () => {
  return client.getEntries({
    content_type: "dashboardCaseStudy"
  });
};

export const loadPlanOnboardingInfo = slug => {
  return client.getEntries({
    content_type: "onboardingPlanModule",
    "fields.slug[in]": slug,
    limit: 1
  });
};
export const loadOnboardingText = slug => {
  return client.getEntries({
    content_type: "onboardingText",
    "fields.slug[in]": slug,
    limit: 1
  });
};

export const loadDashboardStep = slug => {
  return client.getEntries({
    content_type: "dashboardStep",
    "fields.slug[in]": slug,
    limit: 1
  });
};

export const loadFeatureInfo = slug => {
  return client.getEntries({
    content_type: "getFeatureSection",
    "fields.slug[in]": slug,
    limit: 1
  });
};

export const loadEngines = () => {
  return client.getEntries({
    content_type: "enginePricing",
    order: "fields.engineOrder"
  });
};
export const loadEngine = slug => {
  return client.getEntries({
    content_type: "enginePricing",
    "fields.slug[in]": slug,
    order: "fields.engineOrder",
    limit: 1
  });
};

export const loadPlans = slug => {
  return client.getEntries({
    content_type: "pricingPlan",
    "fields.slug[in]": slug
  });
};

export const loadSignUpOnboarding = (slug = "onboarding") => {
  let query = {
    content_type: "signUpOnboarding",
    order: "sys.createdAt",
    "fields.slug[in]": slug,
    limit: 1
  };

  return client.getEntries(query);
};

export const loadOnboardingLandingPage = slug => {
  return client.getEntries({
    content_type: "onboadingLandingPage",
    "fields.slug[in]": slug,
    limit: 1
  });
};

export const loadCancelCenter = slug => {
  return client.getEntries({
    content_type: "cancelCenter",
    "fields.slug[in]": slug,
    limit: 1
  });
};

export const loadCancelReason = slug => {
  return client.getEntries({
    content_type: "cancelCenterOption",
    "fields.slug[in]": slug,
    limit: 1
  });
};
